// extracted by mini-css-extract-plugin
export default {"formBgContainer":"compPlans_formBgContainer__PsdO0","formTitle":"compPlans_formTitle__CWVRJ","formContainer":"compPlans_formContainer__YEoUo"};